webpackJsonp([263791100135453],{

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(16);
	
	var _theme = __webpack_require__(7);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Title = __webpack_require__(26);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailsContainer = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'about__DetailsContainer',
	  componentId: 'sc-190nmfb-0'
	})(['font-family:', ';font-size:', ';&:first-letter{font-weight:bold;font-size:', ';};color:', ''], _theme.fonts.secondary, _theme.fontSizes[3] + 'px', _theme.fontSizes[6] + 'px', _theme.colors.greyDark);
	var TextSeparator = (0, _styledComponents2.default)(_rebass.Divider).withConfig({
	  displayName: 'about__TextSeparator',
	  componentId: 'sc-190nmfb-1'
	})(['width:30px;height:5px;background-color:', ';border-bottom:none;border-radius:15px;margin-bottom:2rem;position:relative;left:50%;transform:translateX(-50%);'], _theme.colors.secondary);
	var About = function About() {
	  return _react2.default.createElement(
	    _rebass.Box,
	    { px: 5, py: 6, style: { textAlign: 'center' } },
	    _react2.default.createElement(
	      _Title2.default,
	      { color: _theme.colors.primary },
	      'About the Firm'
	    ),
	    _react2.default.createElement(TextSeparator, null),
	    _react2.default.createElement(
	      DetailsContainer,
	      null,
	      'JAIN S N & Co. is a leading firm of Chartered Accountants established in 2012. Led by eminent and highly experienced partners and complemented by a team of multi disciplinary professionals, we offer a diverse range of professional services to our clients, besides our core competencies of audit and taxation. With over 6 YEARS of experience, we have been providing advice and support to both domestic and international clients in diverse sectors on audit, accounting, taxation and regulatory matters. Built on a strong commitment to client service, the Firm acts as a One-Stop Advisor offering expertise and hands-on support. We pride ourselves on our quality and integrity to drive the growth of our clients.'
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-6239c7832fce10f18f28.js